// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/base.scss
// module id = 7
// module chunks = 0